import React from 'react';

import IconType from '../../../types/Icon';

const BookingCancelled: React.FC<IconType> = ({ size = 64 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 64 64`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.4375 44L10.4375 16H53.625L53.9375 17.5625L56.5882 29.9327C55.2055 29.2742 53.7352 28.7698 52.1996 28.4417L50.375 20H14.3125L17.75 44H28.4001C28.1377 45.2924 28 46.6301 28 48H14.25L14 46.3125L13.6875 44H3.4375ZM39.2717 30C37.1937 31.0095 35.3167 32.3683 33.7171 34H24V30H39.2717ZM13.125 40L11.4375 28.4375L8.5625 40H13.125Z"
				fill="#222222"
			/>
			<path
				d="M48 32C39.1875 32 32 39.1875 32 48C32 56.8125 39.1875 64 48 64C56.8125 64 64 56.8125 64 48C64 39.1875 56.8125 32 48 32ZM48 36C50.5781 36 52.9844 36.8125 54.9375 38.1875L38.1875 54.9375C36.8125 52.9844 36 50.5781 36 48C36 41.3516 41.3516 36 48 36ZM57.8125 41.0625C59.1875 43.0156 60 45.4219 60 48C60 54.6484 54.6484 60 48 60C45.4219 60 43.0156 59.1875 41.0625 57.8125L57.8125 41.0625Z"
				fill="#FF2C2C"
			/>
		</svg>
	);
};

export default BookingCancelled;
